import {
  equals,
  includes,
  gte,
  lte
} from 'ramda'

import { countsAsBigCompany } from './companySizes'
import {
  AMOUNT_PER_COMPANY_GROUP_1_BIL_OR_LESS_VALUES,
  ANNUAL_BALANCE_SHEET_TOTAL_VALUE_43_MIO_OR_LESS,
  BOOL_VALUE_YES,
  BOOL_VALUE_NO,
  COUNTRY_VALUE_GERMANY,
  DESIRED_TERM_VALUE_6_OR_LESS,
  DESIRED_TERM_VALUE_6_TO_10,
  PRODUCT_VALUE_LOAN,
  PURPOSE_VALUE_GOODS,
  PURPOSE_VALUE_MACHINE,
  PURPOSE_VALUE_OVERDRAFT_LIQUIDITY,
  PURPOSE_VALUE_REAL_ESTATE,
  PURPOSE_VALUE_RESCHEDULED_DEBT_POST_MARCH,
  PURPOSE_VALUE_VEHICLE,
  FIRST_TURNOVER_VALUE_FIVE_OR_MORE,
  NUMBER_OF_EMPLOYEES_VALUE_10_OR_LESS,
  NUMBER_OF_EMPLOYEES_VALUE_10_TO_50,
  NUMBER_OF_EMPLOYEES_VALUE_50_TO_249,
  ANNUAL_TURNOVER_VALUE_50_MIO_OR_LESS,
  FIRST_TURNOVER_VALUE_THREE_TO_FIVE,
  FIRST_TURNOVER_VALUE_2019_OR_EARLIER,
  PURPOSE_VALUE_ASSISTED_LIVING,
  NUMBER_OF_EMPLOYEES_VALUE_250_OR_MORE,
  MANAGING_DIRECTORS_SALARIES_VALUE_MORE_THAN_150,
  PUBLIC_SECTOR_SHARE_VALUE_LESS_THAN_25_PERCENTAGE,
  PUBLIC_SECTOR_SHARE_VALUE_25_TO_50_PERCENTAGE
} from './enums'

// 'KfW-Unternehmerkredit 037 (groß)'
export const unternehmerGroß =  'kfwUnternehmerGroß' // 2726e52bb68cf77c00cd0099e576a565

// 'KfW-Unternehmerkredit 047 (klein und mittel)'
export const unternehmerKlein =  'kfwUnternehmerKlein' // 2726e52bb68cf77c00cd0099e576a565

// 'ERP-Gründerkredit – Universell (groß) 073, 075 mit Haftungsfreistellung'
export const gründerGroß =  'kfwGründerGroß' // 1526772faea7cad32b7b5c4f634d4ba8

// 'ERP-Gründerkredit – Universell (klein und mittel) 074, 076 mit Haftungsfreistellung'
export const gründerKlein =  'kfwGründerKlein' // b4411ba41bfec1ce32f045d79a9e900a

// 'KfW Schnellkredit 2020 (078)'
export const schnellkredit2020 = 'kfwSchnellkredit2020' // 5e164472dbe368f69a1845068b698ce7

export const getConditions = ({
  amount,
  country,
  'first-turnover': firstTurnover,
  'number-of-employees': numberOfEmployees,
  'annual-turnover': annualTurnover,
  'annual-balance-sheet-total': annualBalanceSheetTotal,
  'sum-of-2017-2019-was-a-profit': sumOf_2017_2019WasAProfit,
  'previous-financial-problems': previousFinancialProblems,
  'could-have-financed-itself-in-non-emergency': couldHaveFinancedItselfInNonEmergency,
  purpose,
  product,
  'amount-per-company-group': amountPerCompanyGroup,
  'public-sector-share': PublicSectorShare,
  'amount-maximum-one-quarter-of-2019-turnover': amountMaximumOneQuarterOf_2019Turnover,
  'amount-maximum-twice-of-2019-loan-expenses': amountMaximumTwiceOf_2019LoanExpenses,
  'amount-matches-liquidity-constraint': amountMatchesLiquidityConstraint,
  'desired-term': desiredTerm,
  'profit-or-dividends-during-term': profitOrDividendsDuringTerm,
  'managing-directors-salaries': managingDirectorsSalaries
}) => {
  const isBigCompany = countsAsBigCompany({
    numberOfEmployees,
    annualTurnover,
    annualBalanceSheetTotal
  })

  const anyOfTheAmountRelatedConditionsMatches =
    amountMaximumOneQuarterOf_2019Turnover === BOOL_VALUE_YES ||
    amountMaximumTwiceOf_2019LoanExpenses === BOOL_VALUE_YES ||
    amountMatchesLiquidityConstraint === BOOL_VALUE_YES

  return {
    'amount': {
      [unternehmerGroß]: true,
      [unternehmerKlein]: true,
      [gründerGroß]: true,
      [gründerKlein]: true,
      [schnellkredit2020]: gte(800000, amount), // 800000 >= value
    },
    'public-sector-share': {
     [unternehmerGroß]: includes(
        PublicSectorShare,
        [
          PUBLIC_SECTOR_SHARE_VALUE_LESS_THAN_25_PERCENTAGE,
          PUBLIC_SECTOR_SHARE_VALUE_25_TO_50_PERCENTAGE
        ]
      ),
      [unternehmerKlein]: includes(
        PublicSectorShare,
        [
         PUBLIC_SECTOR_SHARE_VALUE_LESS_THAN_25_PERCENTAGE,
         PUBLIC_SECTOR_SHARE_VALUE_25_TO_50_PERCENTAGE
        ]
      ),
      [gründerGroß]: includes(
        PublicSectorShare,
        [
          PUBLIC_SECTOR_SHARE_VALUE_LESS_THAN_25_PERCENTAGE,
          PUBLIC_SECTOR_SHARE_VALUE_25_TO_50_PERCENTAGE
        ]
      ),
      [gründerKlein]: includes(
        PublicSectorShare,
        [
          PUBLIC_SECTOR_SHARE_VALUE_LESS_THAN_25_PERCENTAGE,
          PUBLIC_SECTOR_SHARE_VALUE_25_TO_50_PERCENTAGE
        ]
      ),
      [schnellkredit2020]: equals(
        PUBLIC_SECTOR_SHARE_VALUE_LESS_THAN_25_PERCENTAGE,
        PublicSectorShare
      ),
    },
    'country': {
      [unternehmerGroß]: equals(COUNTRY_VALUE_GERMANY, country),
      [unternehmerKlein]: equals(COUNTRY_VALUE_GERMANY, country),
      [gründerGroß]: equals(COUNTRY_VALUE_GERMANY, country),
      [gründerKlein]: equals(COUNTRY_VALUE_GERMANY, country),
      [schnellkredit2020]: equals(COUNTRY_VALUE_GERMANY, country),
    },
    'first-turnover': {
      [unternehmerGroß]: equals(FIRST_TURNOVER_VALUE_FIVE_OR_MORE, firstTurnover),
      [unternehmerKlein]: equals(FIRST_TURNOVER_VALUE_FIVE_OR_MORE, firstTurnover),
      [gründerGroß]: equals(FIRST_TURNOVER_VALUE_THREE_TO_FIVE, firstTurnover),
      [gründerKlein]: equals(FIRST_TURNOVER_VALUE_THREE_TO_FIVE, firstTurnover),
      [schnellkredit2020]: includes(
        firstTurnover,
        [
          FIRST_TURNOVER_VALUE_FIVE_OR_MORE,
          FIRST_TURNOVER_VALUE_THREE_TO_FIVE,
          FIRST_TURNOVER_VALUE_2019_OR_EARLIER
        ]
      ),
    },
    'number-of-employees': {
      [unternehmerGroß]: isBigCompany,
      [unternehmerKlein]: includes(
        numberOfEmployees,
        [
          NUMBER_OF_EMPLOYEES_VALUE_10_OR_LESS,
          NUMBER_OF_EMPLOYEES_VALUE_10_TO_50,
          NUMBER_OF_EMPLOYEES_VALUE_50_TO_249
        ]
      ),
      [gründerGroß]: isBigCompany,
      [gründerKlein]: includes(
        numberOfEmployees,
        [
          NUMBER_OF_EMPLOYEES_VALUE_10_OR_LESS,
          NUMBER_OF_EMPLOYEES_VALUE_10_TO_50,
          NUMBER_OF_EMPLOYEES_VALUE_50_TO_249
        ]
      ),
      [schnellkredit2020]: includes(
        numberOfEmployees,
        [
          NUMBER_OF_EMPLOYEES_VALUE_50_TO_249,
          NUMBER_OF_EMPLOYEES_VALUE_250_OR_MORE
        ]
      ) || ((numberOfEmployees === NUMBER_OF_EMPLOYEES_VALUE_10_TO_50) && gte(500000, amount))
        || ((numberOfEmployees === NUMBER_OF_EMPLOYEES_VALUE_10_OR_LESS) && lte(amount, 300000)),
    },
    'annual-turnover': {
      [unternehmerGroß]: isBigCompany,
      [unternehmerKlein]: equals(ANNUAL_TURNOVER_VALUE_50_MIO_OR_LESS, annualTurnover),
      [gründerGroß]: isBigCompany,
      [gründerKlein]: equals(ANNUAL_TURNOVER_VALUE_50_MIO_OR_LESS, annualTurnover),
      [schnellkredit2020]: true,
    },
    'annual-balance-sheet-total': {
      [unternehmerGroß]: isBigCompany,
      [unternehmerKlein]: equals(ANNUAL_BALANCE_SHEET_TOTAL_VALUE_43_MIO_OR_LESS, annualBalanceSheetTotal),
      [gründerGroß]: isBigCompany,
      [gründerKlein]: equals(ANNUAL_BALANCE_SHEET_TOTAL_VALUE_43_MIO_OR_LESS, annualBalanceSheetTotal),
      [schnellkredit2020]: true,
    },
    'sum-of-2017-2019-was-a-profit': {
      [unternehmerGroß]: true,
      [unternehmerKlein]: true,
      [gründerGroß]: true,
      [gründerKlein]: true,
      [schnellkredit2020]: equals(BOOL_VALUE_YES, sumOf_2017_2019WasAProfit),
    },
    'previous-financial-problems': {
      [unternehmerGroß]: equals(BOOL_VALUE_YES, previousFinancialProblems),
      [unternehmerKlein]: equals(BOOL_VALUE_YES, previousFinancialProblems),
      [gründerGroß]: equals(BOOL_VALUE_YES, previousFinancialProblems),
      [gründerKlein]: equals(BOOL_VALUE_YES, previousFinancialProblems),
      [schnellkredit2020]: equals(BOOL_VALUE_YES, previousFinancialProblems),
    },
    'could-have-financed-itself-in-non-emergency': {
      [unternehmerGroß]: equals(BOOL_VALUE_YES, couldHaveFinancedItselfInNonEmergency),
      [unternehmerKlein]: equals(BOOL_VALUE_YES, couldHaveFinancedItselfInNonEmergency),
      [gründerGroß]: equals(BOOL_VALUE_YES, couldHaveFinancedItselfInNonEmergency),
      [gründerKlein]: equals(BOOL_VALUE_YES, couldHaveFinancedItselfInNonEmergency),
      [schnellkredit2020]: true,
    },
    'purpose': {
      [unternehmerGroß]: includes(
        purpose,
        [
          PURPOSE_VALUE_MACHINE,
          PURPOSE_VALUE_REAL_ESTATE,
          PURPOSE_VALUE_VEHICLE,
          PURPOSE_VALUE_OVERDRAFT_LIQUIDITY,
          PURPOSE_VALUE_GOODS,
          PURPOSE_VALUE_RESCHEDULED_DEBT_POST_MARCH
        ]
      ),
      [unternehmerKlein]: includes(
        purpose,
        [
          PURPOSE_VALUE_MACHINE,
          PURPOSE_VALUE_REAL_ESTATE,
          PURPOSE_VALUE_VEHICLE,
          PURPOSE_VALUE_OVERDRAFT_LIQUIDITY,
          PURPOSE_VALUE_GOODS,
          PURPOSE_VALUE_RESCHEDULED_DEBT_POST_MARCH
        ]
      ),
      [gründerGroß]: includes(
        purpose,
        [
          PURPOSE_VALUE_MACHINE,
          PURPOSE_VALUE_REAL_ESTATE,
          PURPOSE_VALUE_VEHICLE,
          PURPOSE_VALUE_OVERDRAFT_LIQUIDITY,
          PURPOSE_VALUE_GOODS,
          PURPOSE_VALUE_RESCHEDULED_DEBT_POST_MARCH
        ]
      ),
      [gründerKlein]: includes(
        purpose,
        [
          PURPOSE_VALUE_MACHINE,
          PURPOSE_VALUE_REAL_ESTATE,
          PURPOSE_VALUE_VEHICLE,
          PURPOSE_VALUE_OVERDRAFT_LIQUIDITY,
          PURPOSE_VALUE_GOODS,
          PURPOSE_VALUE_RESCHEDULED_DEBT_POST_MARCH
        ]
      ),
      [schnellkredit2020]: includes(
        purpose,
        [
          PURPOSE_VALUE_MACHINE,
          PURPOSE_VALUE_REAL_ESTATE,
          PURPOSE_VALUE_VEHICLE,
          PURPOSE_VALUE_OVERDRAFT_LIQUIDITY,
          PURPOSE_VALUE_ASSISTED_LIVING,
          PURPOSE_VALUE_GOODS
        ]
      ),
    },
    'product': {
      [unternehmerGroß]: equals(PRODUCT_VALUE_LOAN, product),
      [unternehmerKlein]: equals(PRODUCT_VALUE_LOAN, product),
      [gründerGroß]: equals(PRODUCT_VALUE_LOAN, product),
      [gründerKlein]: equals(PRODUCT_VALUE_LOAN, product),
      [schnellkredit2020]: equals(PRODUCT_VALUE_LOAN, product),
    },
    'amount-per-company-group': {
      [unternehmerGroß]: includes(
        amountPerCompanyGroup,
        AMOUNT_PER_COMPANY_GROUP_1_BIL_OR_LESS_VALUES
      ),
      [unternehmerKlein]: includes(
        amountPerCompanyGroup,
        AMOUNT_PER_COMPANY_GROUP_1_BIL_OR_LESS_VALUES
      ),
      [gründerGroß]: includes(
        amountPerCompanyGroup,
        AMOUNT_PER_COMPANY_GROUP_1_BIL_OR_LESS_VALUES
      ),
      [gründerKlein]: includes(
        amountPerCompanyGroup,
        AMOUNT_PER_COMPANY_GROUP_1_BIL_OR_LESS_VALUES
      ),
      [schnellkredit2020]: true,
    },
    'amount-maximum-one-quarter-of-2019-turnover': {
      [unternehmerGroß]: anyOfTheAmountRelatedConditionsMatches,
      [unternehmerKlein]: anyOfTheAmountRelatedConditionsMatches,
      [gründerGroß]: anyOfTheAmountRelatedConditionsMatches,
      [gründerKlein]: anyOfTheAmountRelatedConditionsMatches,
      [schnellkredit2020]: equals(BOOL_VALUE_YES, amountMaximumOneQuarterOf_2019Turnover),
    },
    'amount-maximum-twice-of-2019-loan-expenses': {
      [unternehmerGroß]: anyOfTheAmountRelatedConditionsMatches,
      [unternehmerKlein]: anyOfTheAmountRelatedConditionsMatches,
      [gründerGroß]: anyOfTheAmountRelatedConditionsMatches,
      [gründerKlein]: anyOfTheAmountRelatedConditionsMatches,
      [schnellkredit2020]: true,
    },
    'amount-matches-liquidity-constraint': {
      [unternehmerGroß]: anyOfTheAmountRelatedConditionsMatches,
      [unternehmerKlein]: anyOfTheAmountRelatedConditionsMatches,
      [gründerGroß]: anyOfTheAmountRelatedConditionsMatches,
      [gründerKlein]: anyOfTheAmountRelatedConditionsMatches,
      [schnellkredit2020]: true,
    },
    'desired-term': {
      [unternehmerGroß]: equals(DESIRED_TERM_VALUE_6_OR_LESS, desiredTerm),
      [unternehmerKlein]: equals(
        DESIRED_TERM_VALUE_6_OR_LESS, desiredTerm
      ) || (equals(DESIRED_TERM_VALUE_6_TO_10, desiredTerm) && lte(amount, 800000)),
      [gründerGroß]: equals(DESIRED_TERM_VALUE_6_OR_LESS, desiredTerm),
      [gründerKlein]: equals(DESIRED_TERM_VALUE_6_OR_LESS, desiredTerm),
      [schnellkredit2020]: includes(
        desiredTerm,
        [
          DESIRED_TERM_VALUE_6_OR_LESS,
          DESIRED_TERM_VALUE_6_TO_10
        ]
      ),
    },
    'profit-or-dividends-during-term': {
      [unternehmerGroß]: equals(BOOL_VALUE_NO, profitOrDividendsDuringTerm),
      [unternehmerKlein]: equals(BOOL_VALUE_NO, profitOrDividendsDuringTerm),
      [gründerGroß]: true,
      [gründerKlein]: true,
      [schnellkredit2020]: equals(BOOL_VALUE_NO, profitOrDividendsDuringTerm),
    },
    'managing-directors-salaries': {
      [unternehmerGroß]: true,
      [unternehmerKlein]: true,
      [gründerGroß]: true,
      [gründerKlein]: true,
      [schnellkredit2020]: !equals(MANAGING_DIRECTORS_SALARIES_VALUE_MORE_THAN_150, managingDirectorsSalaries)
    }
  }
}
